import styles from './NCDisclaimerBox.module.css'
import styleUtils from 'shared-components/styles/util.module.css'
import {
  DSNCDisclaimerBox,
  DSResource,
  DSTpl,
  NCComponentInterface,
} from 'shared-definitions/types'
import clsx from 'clsx'
import { ComponentType } from 'react'
import Linked from '../service/Linked'
import AppImage from '../ui/AppImage'
import { ThemeContext } from '../contexts/ThemeContext'

interface NCDisclaimerBoxProps<T extends DSResource> {
  data: DSNCDisclaimerBox<T>
  nc: ComponentType<NCComponentInterface<T>>
  tpl: DSTpl
}

const NCDisclaimerBox = <T extends DSResource>({
  data,
  tpl,
  nc: NC,
}: NCDisclaimerBoxProps<T>): React.ReactElement => {
  const { ready, theme } = ThemeContext.useContainer()
  return (
    <div
      className={clsx(styleUtils.nc, styles.container, {
        [styles.withContent]: data.content.length > 0,
      })}
    >
      {data.content.length > 0 && (
        <div className={styles.content}>
          {data.content.map((item, index) => (
            <NC index={index} key={index} data={item} tpl={tpl} />
          ))}
        </div>
      )}
      <Linked {...data.iconButton.pLink} className={clsx(styles.iconBox)}>
        {data.iconButton.iconDark && (
          <AppImage
            className={clsx(styles.icon, {
              [styles.hidden]: (ready && theme === 'light') || !ready,
            })}
            layout="responsive"
            image={data.iconButton.iconDark}
            sizes={150}
          />
        )}
        {data.iconButton.iconLight && (
          <AppImage
            className={clsx(styles.icon, {
              [styles.hidden]: ready && theme === 'dark',
            })}
            layout="responsive"
            image={data.iconButton.iconLight}
            sizes={150}
          />
        )}
      </Linked>
    </div>
  )
}

export default NCDisclaimerBox
